import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { format } from "date-fns";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Fetches available slots for a given selected date.
 * Returns { isoDate, slots, loadingSlots } — the selected time state
 * lives in the parent form so it can be reset independently.
 */
export default function useAvailability(date) {
  const [slots, setSlots] = useState([]);
  const [loadingSlots, setLoadingSlots] = useState(false);

  const isoDate = useMemo(
    () => (date ? format(date, "yyyy-MM-dd") : ""),
    [date],
  );

  useEffect(() => {
    if (!isoDate) {
      setSlots([]);
      return;
    }
    let cancelled = false;
    setLoadingSlots(true);
    axios
      .get(`${API}/availability`, { params: { date: isoDate } })
      .then((res) => {
        if (!cancelled) setSlots(res.data.slots || []);
      })
      .catch(() => {
        if (!cancelled) {
          setSlots([]);
          toast.error("Impossible de charger les créneaux. Réessayez.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoadingSlots(false);
      });
    return () => {
      cancelled = true;
    };
  }, [isoDate]);

  return { isoDate, slots, loadingSlots };
}
